(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Try curated complementary products first, fall back to automatic recommendations
  var applyResponse = function(response) {
    var container = document.createElement("div");
    container.innerHTML = response;
    var inner = container.querySelector('.related-products');
    if (inner && inner.querySelector('.product-block')) {
      relatedProductsSection.innerHTML = inner.innerHTML;
      theme.initAnimateOnScroll();
      return true;
    }
    return false;
  };
  var fetchRecommendations = function(url, onEmpty) {
    var request = new XMLHttpRequest();
    request.open("GET", url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        if (!applyResponse(request.response) && onEmpty) { onEmpty(); }
      } else if (onEmpty) { onEmpty(); }
    };
    request.onerror = function() { if (onEmpty) { onEmpty(); } };
    request.send();
  };
  var baseUrl = relatedProductsSection.dataset.url;
  fetchRecommendations(baseUrl + '&intent=complementary', function() {
    fetchRecommendations(baseUrl, null);
  });
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
